import { useForm } from 'vee-validate'
import { sendMailSchema } from '~/validators/forgot-password-send-mail.schema'
import { resetPasswordSchema } from '~/validators/forgot-password-reset.schema'

export const useForgotPasswordSendMail = () =>
  useForm({
    initialValues: {
      email: '',
    },
    validationSchema: sendMailSchema,
  })

export const useForgotPasswordReset  = () => {
  return useForm({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: resetPasswordSchema,
  })
}
